module.exports = __webpack_public_path__ + "static/media/ic-notif-audit.86ac5979.svg";